import { cardCommonStyle } from '@styles/common/Card';
import { scrollbarHide, scrollbarStyle } from '@styles/variants/scrollbar';
import styled, { css } from 'styled-components';

const titleType = {
  transparent: css`
    font-size: 20px;
    font-weight: 700;
    padding: 12px 14px;
  `,
  default: css`
    font-size: 15px;
    font-weight: 700;
    background-color: var(--subColor);
    color: var(--subTextColor);
    border-radius: var(--cardBorderRadius);
  `,
};

export const BoxTitle = styled.div<{
  type: keyof typeof titleType;
}>`
  padding: 6px;
  width: 100%;
  font-family: var(--headerFontFamily);
  ${({ type }) => type && titleType[type]}
`;

export const MainHomeBox = styled.div<{
  mobileMaxHeight?: string;
  $isBackground?: boolean;
}>`
  width: 100%;
  height: 100%;
  padding: ${({ $isBackground = true }) => ($isBackground ? '8px' : '0')};
  ${({ $isBackground = true }) => $isBackground && cardCommonStyle};
  ${({ $isBackground = true }) =>
    !$isBackground &&
    `
    background: transparent;
    border: none;
    box-shadow: none;
  `};
  overflow-y: auto;
  
  ${scrollbarHide}
  @media (max-width: 480px) {
    max-height: ${({ mobileMaxHeight }) => mobileMaxHeight};
    overflow-y: auto;
  }
`;

export const AsideBox = styled.div`
${cardCommonStyle};
overflow:unset; // 드롭다운 막힘 방지
  height: fit-content;
  padding: 16px 0;
  z-index: 2; // UserInfoSec이 zindex 1이라서 2로 설정
`;
